class StepoyShopLook extends HTMLElement {
  connectedCallback() {
    this.hotspots = Array.from(this.querySelectorAll('[data-spc-hotspot]'));
    this.products = Array.from(this.querySelectorAll('[data-spc-product]'));
    this.counter = this.querySelector('[data-spc-counter]');
    this.previousButton = this.querySelector('[data-spc-previous]');
    this.nextButton = this.querySelector('[data-spc-next]');
    this.mobileQuery = window.matchMedia('(max-width: 749px)');

    if (!this.products.length) return;

    this.hotspots.forEach((hotspot, index) => {
      hotspot.addEventListener('click', () => this.setActive(index, true));
    });

    this.previousButton?.addEventListener('click', () => this.setActive(this.activeIndex - 1));
    this.nextButton?.addEventListener('click', () => this.setActive(this.activeIndex + 1));

    this.onBlockSelect = (event) => {
      const blockId = event.detail?.blockId || event.target?.dataset?.blockId;
      if (!blockId) return;
      const index = this.hotspots.findIndex((hotspot) => hotspot.dataset.blockId === blockId);
      if (index >= 0) this.setActive(index);
    };

    document.addEventListener('shopify:block:select', this.onBlockSelect);
    this.onViewportChange = () => this.setActive(this.activeIndex || 0);
    if (this.mobileQuery.addEventListener) {
      this.mobileQuery.addEventListener('change', this.onViewportChange);
    } else {
      this.mobileQuery.addListener(this.onViewportChange);
    }
    this.setActive(0);
  }

  disconnectedCallback() {
    document.removeEventListener('shopify:block:select', this.onBlockSelect);
    if (this.mobileQuery?.removeEventListener) {
      this.mobileQuery.removeEventListener('change', this.onViewportChange);
    } else {
      this.mobileQuery?.removeListener(this.onViewportChange);
    }
  }

  setActive(index, scrollToProduct = false) {
    const length = this.products.length;
    this.activeIndex = (index + length) % length;
    const showAllProducts = this.mobileQuery?.matches;

    this.hotspots.forEach((hotspot, hotspotIndex) => {
      const active = hotspotIndex === this.activeIndex;
      hotspot.classList.toggle('is-active', active);
      hotspot.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    this.products.forEach((product, productIndex) => {
      const active = productIndex === this.activeIndex;
      product.classList.toggle('is-active', active);
      product.hidden = showAllProducts ? false : !active;
    });

    if (showAllProducts && scrollToProduct) {
      this.products[this.activeIndex]?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    if (this.counter) {
      const current = String(this.activeIndex + 1).padStart(2, '0');
      const total = String(length).padStart(2, '0');
      this.counter.textContent = `${current} / ${total}`;
    }
  }
}

if (!customElements.get('stepoy-shop-look')) {
  customElements.define('stepoy-shop-look', StepoyShopLook);
}
